import {useNavigate, useParams} from "react-router-dom";
import {AppPage} from "common/Layout";
import {AppButton} from "shared/UI/UIKit/Button";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import {AppImage} from "shared/UI/UIKit/Image";
import {
  getAdditionalMaterialsUrl,
  getAnnotationUrl, getHomeUrl,
  getInteractiveUrl,
  getLiteratureUrl, getMethodologicalModuleUrl, getPracticalModuleUrl,
  getTargetUrl,
  getTestUrl,
  getTheoryUrl, getVideoUrl
} from "services/navigation";
import type {TheoryPage as TheoryPageType,
  InteractivePage as InteractivePageType,
  MethodologicalModulePage as MethodologicalModulePageType,
  Page, PracticalModulePage as PracticalModulePageType
} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {
  PageType
} from "../../config/types";
import styles from "./styles.module.scss";

type IdParams = { id: string; }

export const TheoryPage = () => {
  const navigate = useNavigate();
  const {id} = useParams<IdParams>();
  const theoryPage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.THEORY && page.id === id) as TheoryPageType;

  console.log(id);
  console.log(theoryPage);

  if (!theoryPage) {
    return null;
  }

  // const downloadPdf = () => {
  //   const newWin = window.open("");
  //   newWin!.location.href = theoryPage.pdfPath;
  // };

  const getUrl = (page: Page) => {
    switch (page.type) {
      case PageType.ANNOTATION:
        return getAnnotationUrl();
      case PageType.INTERACTIVE:
        return getInteractiveUrl({id: (page as InteractivePageType).id});
      case PageType.LITERATURE:
        return getLiteratureUrl();
      case PageType.TARGET:
        return getTargetUrl();
      case PageType.TEST:
        return getTestUrl();
      case PageType.THEORY:
        return getTheoryUrl({id: (page as TheoryPageType).id});
      case PageType.VIDEO:
        return getVideoUrl();
      case PageType.METHODOLOGICAL_MODULE:
        return getMethodologicalModuleUrl({id: (page as MethodologicalModulePageType).id});
      case PageType.PRACTICAL_MODULE:
        return getPracticalModuleUrl({id: (page as PracticalModulePageType).id});
      case PageType.ADDITIONAL_MATERIALS:
        return getAdditionalMaterialsUrl();
      default:
        return getHomeUrl();
    }
  };

  const goToNextPage = () => {
    const nextPage = GLOBAL_CONFIG.pages.find(page => page.order === theoryPage.order + 1);

    if (nextPage) {
      const url = getUrl(nextPage);
      navigate(url);
    }
  };

  return (
    <AppPage contentClassName={styles.content} pageTitle="Аннотация" documentTitle="Аннотация">
      {/*<AppButton onClick={downloadPdf} className={styles.pdf}>Скачать PDF</AppButton>*/}
      <AppFlex unit="30">
        <AppText size={24} className={styles.title}>{theoryPage.title}</AppText>
        <div style={{fontSize: "18px"}}>
          {
            theoryPage.content.map((item, index) => {
              switch (item.type) {
                case "block":
                  return (
                    <div key={index} className={styles.block} dangerouslySetInnerHTML={{__html: item.text}}>
                    </div>
                  );
                case "text":
                  return (
                    <div key={index} className={styles.block} dangerouslySetInnerHTML={{__html: item.text}}>
                    </div>
                  );
                case "image":
                  return (
                    <AppImage key={index} src={item.imagePath} alt="image" className={styles.image}/>
                  );
                default:
                  return null;
              }
            })
          }
        </div>
      </AppFlex>
      <AppButton className={styles.nextPageBtn} onClick={goToNextPage} style={{display: "block", margin: "24px 0 0 auto", lineHeight: "16px"}}>{theoryPage.nextBtnName}</AppButton>
    </AppPage>
  );
};
